module.exports = __webpack_public_path__ + "static/mreavesxlsannarr-020415006EmigreWebOnly-27d9c3af03a766de7f4c776a7ecf2c18.ttf";